import { GlobalDesignAction } from '../types';
import { rootHostGroupingStrategy } from '../common/grouping/rootHostGroupingStrategy';

export const spacingGrouping: GlobalDesignAction<'spacingStyles'>['grouping'] =
  {
    getGroupingStrategy: (editorPointer, getHost) => {
      return () => {
        return rootHostGroupingStrategy(editorPointer, getHost);
      };
    },
  };
